export default function CameraIcon({ name, size = 24 }) {
  const paths = {
    back: <><path d="M5 12h15"/><path d="m14 5 7 7-7 7"/></>,
    switch: <>
      <path d="M5.4 9A7.5 7.5 0 0 1 18.7 6.7" />
      <path d="M18.7 3.5v3.2h-3.2" />
      <path d="M18.6 15A7.5 7.5 0 0 1 5.3 17.3" />
      <path d="M5.3 20.5v-3.2h3.2" />
      <circle cx="12" cy="12" r="2.35" />
    </>,
    gallery: <><rect x="3" y="4" width="18" height="16" rx="2"/><circle cx="9" cy="10" r="2"/><path d="m21 15-5-5L5 20"/></>,
    camera: <><path d="M8 6 9.5 4h5L16 6h3a2 2 0 0 1 2 2v10H3V8a2 2 0 0 1 2-2h3Z"/><circle cx="12" cy="12" r="4"/></>,
    retry: <><path d="M20 11a8 8 0 1 0-2.3 5.7"/><path d="M20 4v7h-7"/></>,
  };
  return <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">{paths[name]}</svg>;
}
